import { ILocation } from 'src/interfaces';

export const checkIsDefaultLocationGroup = (
  location: ILocation | undefined,
) => {
  const locationGroup = location?.locationGroups?.find(
    (item) => item.is_default,
  );

  return locationGroup ? true : false;
};
